import { useCallback, useEffect, useRef } from 'react';

export const useIncrementInterval = ({
  value,
  maxValue,
  onChange,
}: {
  value: number;
  maxValue: number;
  onChange: (value: number) => void;
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const valueRef = useRef(value);

  // Keep valueRef up to date
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const incrementValue = useCallback(() => {
    onChange((valueRef.current + 1) % maxValue);
  }, [maxValue, onChange]);

  const start = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(incrementValue, 3000);
  }, [incrementValue]);

  const stop = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  return { start, stop };
};
